import React from "react";

import AOS from "aos";
import "aos/dist/aos.css";
import help from "../assets/img/help.png";

function Works4() {
  return (
    <div className="container mx-auto">
      {/* <div className="flex flex-col gap-20 px-4 py-20 bg-gray-200 mt-72"> */}
      <div className="flex flex-col gap-20 pb-52 pt-28 mt-72 px-28">
        {/* section1 */}
        <section className="flex items-center justify-center w-full gap-20">
          <div className="w-1/2">
            <img src={help} alt="logo" />
          </div>
          <div className="flex flex-col w-1/2 text-4xl font-bold leading-relaxed">
            <p className="text-gray-800">코끼리협동조합은</p>
            <p className="text-main">'협동조합 창업 지원 사업'</p>
            <p className="text-gray-800">지원 기관입니다.</p>
          </div>
        </section>
        {/* section2 */}
        <section className="flex gap-20">
          {/* 1 모집대상 */}
          <div className="flex flex-col w-full">
            <p className="text-2xl font-semibold text-gray-800">| 모집 대상</p>
            <div className="flex flex-col gap-4 mt-10">
              {/* 1 */}
              <div className="flex">
                <p className="w-1/5 text-xl font-semibold text-gray-600">
                  신규 설립
                </p>
                <p className="w-4/5 text-base leading-6 text-gray-600">
                  <p>· (사회적)협동조합을 신규 설립하려는 자</p>
                  <p>· 협동조합 신규 설립에 결격사유가 없는 개인 또는 법인</p>
                  <p>· 신청 당시 최소 3명 이상의 팀원이 구성되어야 함</p>
                </p>
              </div>
              {/* 2 */}
              <div className="flex">
                <p className="w-1/5 text-xl font-semibold text-gray-600">
                  연합회
                </p>
                <p className="w-4/5 text-base leading-6 text-gray-600">
                  <p>
                    · (일반/사회적/이종)협동조합연합회를 설립하려는 협동조합
                  </p>
                  <p>· 신청 당시 최소 3개소 이상의 팀원이 구성되어야 함</p>
                </p>
              </div>
              {/* 3 */}
              <div className="flex">
                <p className="w-1/5 text-xl font-semibold text-gray-600">
                  조직 변경
                </p>
                <p className="w-4/5 text-base leading-6 text-gray-600">
                  <p>· (사회적)협동조합으로 조직 변경하려는 법인</p>
                  <p>· 협동조합으로 조직변경에 결격사유가 없는 법인</p>
                </p>
              </div>
              {/* 4 */}
              <div className="flex">
                <p className="w-1/5 text-xl font-semibold text-gray-600">
                  모집 규모
                </p>
                <p className="w-4/5 text-base leading-6 text-gray-600">
                  <p>· 코끼리협동조합 5개 팀 모집</p>
                </p>
              </div>
            </div>
          </div>

          {/* 1 지원내용 */}
          <div className="flex flex-col w-full">
            <p className="text-2xl font-semibold text-gray-800">| 지원 내용</p>
            <div className="flex flex-col gap-4 mt-10">
              {/* 1 */}
              <div className="flex">
                <p className="w-1/5 text-xl font-semibold text-gray-600">
                  설립 지원
                </p>
                <p className="w-4/5 text-base leading-6 text-gray-600">
                  <p>· 창업팀 개별화 코칭 전략 수립에 따른 상담</p>
                  <p>
                    · 협동조합 설립을 위한 기본 이해 및 비즈니스 모델 개발 교육
                    지원
                  </p>
                  <p>
                    · 시제품 및 시서비스 개발을 위한 디지털 교육 및 크라우드
                    펀딩 등
                  </p>
                  <p>· 협동조합 네트워킹 및 자원 연계</p>
                  <p>
                    · 협동조합 브랜드 구축 지원 외 창업팀 수행 수준에 따른
                    맞춤형 지원
                  </p>
                </p>
              </div>
              {/* 2 */}
              <div className="flex">
                <p className="w-1/5 text-xl font-semibold text-gray-600">
                  설립 지원비
                </p>
                <p className="w-4/5 text-base leading-6 text-gray-600">
                  <p>· [기본사업비] 500만원</p>
                  <p>· [추가사업비] 최대 200만원 +a(공고문 참고)</p>
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

AOS.init();
export default Works4;
